// Location-based minimum break constraint
// For each same-day consecutive pair (a -> b), if locations differ and gap < minBreak, then
// for every user U: sum_R x_{U,a,R} + sum_R x_{U,b,R} <= 1
// Requires: idx.adjacencyEdges, idx.eventLocation, idx.users, idx.staffRequiredByRole, idx.decisionVariables
export function buildLocationMinBreakConstraints(model, params = {}) {
  const idx = model?.optimizationIndexes || {};
  const edges = Array.isArray(idx.adjacencyEdges) ? idx.adjacencyEdges : [];
  const eventLocation = idx.eventLocation || {};
  const byRole = idx.staffRequiredByRole || {};
  const users = Object.keys(idx.users || {});
  const declared = new Set(Object.keys(idx.decisionVariables || {}));

  const minBreakMinutes = Number(params?.minBreakMinutes) > 0 ? Number(params.minBreakMinutes) : 30;
  const minBreakMs = minBreakMinutes * 60 * 1000;

  if (!edges.length || !users.length) return [];

  const constraints = [];
  for (const edge of edges) {
    const a = edge?.a;
    const b = edge?.b;
    const gap = Number(edge?.gapMs) || 0;
    if (!a || !b) continue;
    if (!(gap < minBreakMs)) continue;
    const la = String(eventLocation[a] || '').trim();
    const lb = String(eventLocation[b] || '').trim();
    // If both non-empty and equal, same location -> no required break
    if (la && lb && la === lb) continue;
    // Otherwise, enforce no same-user back-to-back assignment when gap insufficient
    const rolesA = Object.keys(byRole[a] || {});
    const rolesB = Object.keys(byRole[b] || {});
    for (const uKey of users) {
      const vars = [
        ...rolesA.map((r) => `x_${uKey}_${a}_${r}`),
        ...rolesB.map((r) => `x_${uKey}_${b}_${r}`),
      ].filter((name) => declared.has(name));
      if (!vars.length) continue;
      const coeffs = vars.map(() => 1);
      constraints.push({ linear: { vars, coeffs }, domain: [-100000, 1] });
    }
  }

  return constraints;
}

